import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import MapService from './../utils/MapService';
import { goToLink } from './../utils/Functions';
import Times from './bper-times';
import Button from './bper-button';
import AvailableServices from './bper-available-services';

const Marker = ({ children }) => children;

export default function SubsidiaryDetail({ bank, groupId, translations, subsidiaryId }) {
    const apiKey = "AIzaSyAceI3L01EHMPh2gWtxOOCdqwvNQn-kx6M"
    const [subsidiary, setSubsidiary] = useState(undefined);
    const [place, setPlace] = useState(JSON.parse(localStorage.getItem("place-search")));
    const [apiKey2, setApiKey] = useState(undefined);
    const mapRef = useRef();
    const zoom = 15;

    useEffect(() => {
        getConfigurations(bank);

        getSubsidiary(groupId, bank, subsidiaryId);
    }, [apiKey]);

    useEffect(() => {
        // setGeolocationPosition();
    }, []);

    const getConfigurations = (bank) => {
        MapService.getConfigurations(bank).then((response) => {
            setApiKey("AIzaSyAceI3L01EHMPh2gWtxOOCdqwvNQn-kx6M");
        });
    };

    const getSubsidiary = (groupId, bank, subsidiaryId) => {
        MapService.getSubsidiary(groupId, bank, subsidiaryId).then((response) => {
            response.data.payload.toString() !== "no data"
                ? setSubsidiary(response.data.payload)
                : console.error("Custom Error. No data for subsidiary " + subsidiaryId + ". Response:", response);
        });
    };
    /*
        const setGeolocationPosition = (apiKey) => {
            if (navigator.geolocation) {
                //check if browser support geolocation
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        const userPosition = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        if (!(isNaN(position.coords.latitude) || isNaN(position.coords.longitude))) {
                            setPlace(userPosition);
                        }
                    },
                );
            }
        };
    */

    const linkIndicazioniStradali = place && subsidiary
        ? 'https://www.google.com/maps/dir/' +
        place.lat +
        ',' +
        place.lng +
        '/' +
        subsidiary.latitude +
        ',' +
        subsidiary.longitude
        : !place && subsidiary
            ? 'https://www.google.com/maps/dir//' +
            subsidiary.latitude +
            ',' +
            subsidiary.longitude
            : undefined;

    let subsidiaryType = "";
    try {
        subsidiaryType = subsidiary ? subsidiary.subsdiaryType ? subsidiary.subsdiaryType.replace(/\s/g, '').toLowerCase() : "" : "";
    } catch (er) { }

    return (
        <div className="filiali-bper">
            {subsidiary &&
                <div className="detail">
                    <div className="bper-wrapper">
                        <div className="name-directions">
                            <div className="intro">
                                <h1>
                                    {subsidiary.subsidiaryDescription}
                                </h1>
                                <p>
                                    {subsidiary.address}
                                </p>
                            </div>
                            <div className="directions">
                                {linkIndicazioniStradali &&
                                    <Button
                                        variant="outlined"
                                        onClick={() =>
                                            goToLink(linkIndicazioniStradali, '_blank')
                                        }
                                    >
                                        {translations.Directions}
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="bper-wrapper">
                        {subsidiary.areaSelf && (
                            <div className="area-self">
                                <a>
                                    <span>{translations.areaSelfLabel}</span>
                                    <span className="icon-area-self" style={{ position: "relative" }}>
                                        <svg
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%,-50%)"
                                            }}
                                            width="92px" height="92px" viewBox="0 0 92 92" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <defs>
                                                <filter x="-120.0%" y="-120.0%" width="340.0%" height="340.0%" filterUnits="objectBoundingBox" id="filter-1">
                                                    <feGaussianBlur stdDeviation="8" in="SourceGraphic"></feGaussianBlur>
                                                </filter>
                                                <filter x="-180.0%" y="-180.0%" width="460.0%" height="460.0%" filterUnits="objectBoundingBox" id="filter-2">
                                                    <feGaussianBlur stdDeviation="12" in="SourceGraphic"></feGaussianBlur>
                                                </filter>
                                            </defs>
                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="08_Pagina-Filiale" transform="translate(-212.000000, -347.000000)">
                                                    <g id="Group-9" transform="translate(240.000000, 375.000000)">
                                                        <path d="M36,18 C36,27.9411429 27.9405,36 18,36 C8.05821429,36 0,27.9411429 0,18 C0,8.05885714 8.05821429,0 18,0 C27.9405,0 36,8.05885714 36,18" id="Fill-1" fill="#006369"></path>
                                                        <circle id="Oval" fill="#00B77A" filter="url(#filter-1)" cx="18" cy="18" r="10"></circle>
                                                        <circle id="Oval" fill="#00B77A" filter="url(#filter-2)" cx="18" cy="18" r="10"></circle>
                                                        <g id="Group-30" transform="translate(7.000000, 6.000000)" fill="#FFFFFF">
                                                            <path d="M19.4981349,6.77092114 L12.1789234,6.77092114 C11.9865806,6.77092114 11.8100777,6.876144 11.7195634,7.04585829 L9.694872,10.8129497 L10.2170263,12.0422469 L12.4900663,7.81296686 L18.604872,7.81296686 L15.1110206,13.9860411 C16.1066777,14.3305611 16.6791806,15.1638583 16.6791806,16.2952869 C16.6791806,17.7932983 15.6343063,18.760104 14.0174949,18.760104 L8.744472,18.760104 C8.54703771,18.760104 8.35469486,18.7414354 8.170272,18.7052297 L8.170272,20.1534583 L21.1358777,20.1534583 L21.1358777,9.93892114 C21.1358777,9.86933829 21.1223006,9.80032114 21.0951463,9.73639543 L19.9795577,7.089984 C19.8788606,6.86482971 19.6452206,6.77092114 19.4981349,6.77092114" id="Fill-3"></path>
                                                            <path d="M14.0172686,17.7172663 C15.0389486,17.7172663 15.6363429,17.218872 15.6363429,16.2950606 C15.6363429,15.5228606 15.2561829,15.1127177 14.7142286,14.9475291 L10.1144057,14.4655406 L8.26452,10.1135006 C7.50533143,8.24494629 6.17364,7.43936914 4.72710857,7.43936914 C2.74032,7.43936914 1.24230857,8.60304343 0.821982857,11.2522834 L-1.08173026e-12,20.1537977 L6.61206857,20.1537977 L6.61206857,17.971272 L4.10538857,12.8102606 L5.08350857,12.5432434 C5.62998857,13.674672 6.50232,15.4798663 7.01542286,16.5253063 C7.38936,17.2873234 7.97713714,17.7172663 8.74481143,17.7172663 L14.0172686,17.7172663 Z" id="Fill-5"></path>
                                                            <path d="M7.81811486,7.21512 C5.82623486,7.21512 4.21112057,5.59944 4.21112057,3.60756 C4.21112057,1.61568 5.82623486,2.28226327e-13 7.81811486,2.28226327e-13 C9.81056057,2.28226327e-13 11.4256749,1.61568 11.4256749,3.60756 C11.4256749,5.59944 9.81056057,7.21512 7.81811486,7.21512 Z" id="Fill-7"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        )}
                    </div>
                    <div className={((subsidiary.subsdiaryType !== "CI") ? "bper-wrapper " : " fix-height ") + " times-map-wrapper"}>
                        <div className={"times-map " + ((subsidiary.subsdiaryType === "CI") ? "CI" : "")}>
                            {
                                subsidiary.subsdiaryType !== "CI" &&
                                <Times translations={translations} subsidiary={subsidiary} type="detail" cashLight={subsidiary.cashLight} />
                            }
                            <section id="map-section">
                                <div className="google-map">
                                    <div className="google-map-content">
                                        <GoogleMapReact
                                            bootstrapURLKeys={{
                                                key: apiKey,
                                                libraries: ['places', 'geometry']
                                            }}
                                            defaultCenter={{
                                                lat: parseFloat(subsidiary.latitude && subsidiary.latitude.toString()),
                                                lng: parseFloat(subsidiary.longitude && subsidiary.longitude.toString())
                                            }}
                                            key="map-react"
                                            yesIWantToUseGoogleMapApiInternals={true}
                                            defaultZoom={zoom}
                                        >
                                            <Marker
                                                lat={parseFloat(subsidiary.latitude && subsidiary.latitude.toString())}
                                                lng={parseFloat(subsidiary.longitude && subsidiary.longitude.toString())}
                                            >
                                                <div>
                                                    <svg
                                                        className="marker-icon"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="36"
                                                        height="48"
                                                        viewBox="0 0 36 48"
                                                    >
                                                        <path
                                                            style={{
                                                                color: '#00B97F',
                                                                fill: '#00B97F'
                                                            }}
                                                            id="icn-pointer"
                                                            d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
                                                            transform="translate(36 0)"
                                                            fill="#006369"
                                                        />
                                                    </svg>
                                                </div>
                                            </Marker>
                                        </GoogleMapReact>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                    <div className="bper-wrapper">

                        <div className="orario-contatti">
                            <div className="row horizontal contacts" style={{ fontWeight: 400 }}>
                                <h3>{translations.contacts}</h3>
                                {subsidiary.contacts &&
                                    <div className=" contacts-list">
                                        {subsidiary.contacts.phone && (
                                            <a
                                                href={'tel:' + subsidiary.contacts.phone}
                                                className="phone"
                                                style={{ fontWeight: 400 }}
                                            >
                                                <span>
                                                    {subsidiary.contacts.phone}
                                                </span>
                                            </a>
                                        )}
                                        {subsidiary.contacts.fax && (
                                            <a href={'fax:' + subsidiary.contacts.fax} className="fax" style={{ fontWeight: 400 }}>
                                                <span>
                                                    {subsidiary.contacts.fax}
                                                </span>
                                            </a>
                                        )}
                                        {/*
                                            subsidiary.contacts.email && (
                                                <a href={'mailto:' + subsidiary.contacts.email} className="email">
                                                    <span>
                                                        {subsidiary.contacts.email}
                                                    </span>
                                                </a>
                                            )*/
                                        }
                                    </div>
                                }
                            </div>
                            <div className={"subsidiary-contact-link type-"+subsidiaryType}>
                                <Button
                                    variant="outlined"
                                    /*onClick={() =>
                                        goToLink("/form-contatti?__subsidiaryId=" + subsidiary.subsidiaryId, '_self')
                                    }*/
                                    href={"/form-contatti?__subsidiaryId=" + subsidiary.subsidiaryId}
                                    className="btn btn-default appointment tealium-event"
                                    dataLabel=""
                                    dataCategory=""
                                    dataPosizione=""
                                    dataFiliale={subsidiary.subsidiaryId}
                                    dataLinkId="richiesta contatto-filiale"
                                    dataParam={"__subsidiaryId:" + subsidiary.subsidiaryId}
                                >
                                    {translations.askAppointment}
                                </Button>
                            </div>

                        </div>
                    </div>
                    <AvailableServices services={subsidiary.services} translations={translations} />
                </div>
            }

        </div >
    );
}